import NavBar from "../../NavBar";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import "./style.css";
import { useResponsive } from "../../hooks/useResponsive";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import storePersist, { localConstant } from "../../services/localStorage";
import MenuBar from "../menuBar";
import { stateListRequest } from "../../redux/signup/action";
import { getProfileDetails } from "../../redux/profile/action";
import { useTranslation } from "react-i18next";
import { stateListDriverRequest } from "../../redux/driver/action";

const ProfileView = () => {
  const lgUp = useResponsive("up", "lg");
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [profileInformation, setProfileInformation] = useState({
    "Phone Number": "",
    Address: "",
    City: "",
    State: "",
    Zip: "",
  });
  const [companyInformation, setCompanyInformation] = useState({
    Name: "",
    "Phone Number": "",
    Address: "",
    City: "",
    State: "",
    Zip: "",
  });

  const handleClose = () => {
    setOpen(false);
  };

  const dispatch = useDispatch();
  const [stateList, setStateList] = useState({});

  let userId = storePersist.get(localConstant.USER_ID);

  const { profileDetails } = useSelector((state) => state.profileReducer);
  useEffect(() => {
    if (!storePersist.get(localConstant.STATE_LIST))
      dispatch(
        stateListRequest({}, (data) => {
          setStateList(data?.resultObject);
        }),
      );
    else setStateList(storePersist.get(localConstant.STATE_LIST));
    dispatch(getProfileDetails(userId));
    dispatch(stateListDriverRequest({}, (response) => {}));
  }, []);

  useEffect(() => {
    const stateName = String(
      profileDetails?.countryCode === "+1" ||
        profileDetails?.countryCode === "USA"
        ? stateList?.["USA"]?.find(
            (item) => item?.code === profileDetails?.stateCode,
          )?.description
        : "",
    );
    setProfileInformation({
      [t("pages.profile.key01")]: `${
        profileDetails?.countryCode === null
          ? "+1"
          : profileDetails?.countryCode
      }${profileDetails?.phoneNumber}`,
      [t("pages.profile.key02")]: profileDetails?.addressLine1,
      [t("pages.profile.key03")]: profileDetails?.city,
      [t("pages.profile.key04")]:
        stateName.charAt(0).toUpperCase() + stateName.slice(1).toLowerCase(),
      [t("pages.profile.key05")]: profileDetails?.postalCode,
    });

    console.log(profileDetails, "ayush--tejasva----123");
    const companyState = String(
      profileDetails?.companyCountryCode === "+1" ||
        profileDetails?.companyCountryCode === "USA"
        ? stateList?.["USA"]?.find(
            (item) => item?.code === profileDetails?.companyStateCode,
          )?.description
        : "",
    );

    setCompanyInformation({
      [t("pages.profile.key06")]: profileDetails?.companyName,
      [t("pages.profile.key12")]: profileDetails?.companyEmail,
      [t("pages.profile.key01")]: `${
        profileDetails?.companyCountryCode === null
          ? "+1"
          : profileDetails?.companyCountryCode
      }${profileDetails?.companyPhoneNumber}`,
      [t("pages.profile.key02")]: profileDetails?.companyAddressLine1,
      [t("pages.profile.key03")]: profileDetails?.companyCity,
      [t("pages.profile.key04")]:
        companyState.charAt(0).toUpperCase() +
        companyState.slice(1).toLowerCase(),
      [t("pages.profile.key05")]: profileDetails?.companyPostalCode,
    });
  }, [profileDetails, stateList, t]);

  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <NavBar
        title={t("pages.profile.pageHeading")}
        enableBack={true}
        enableMenu={false}
        isReDirect={false}
        redirectTo="/editProfile"
        redirectToData={profileDetails}
      />
      <MenuBar />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            width: "100%",
            flexDirection: "column",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 10,
          }}
        >
          <div className="user_name_wrapper">
            <div className="user_name_short">{profileDetails?.shortName}</div>
          </div>
          <div className="user_name_view">
            <div className="user_name_title">{profileDetails?.name}</div>
          </div>
          <div className="user_emai_view">
            <div className="user_email_title">{profileDetails?.userEmail}</div>
          </div>
        </div>
        <Divider width={"100%"} />
        {Object.keys(profileInformation).map((vd) => {
          return (
            <>
              {" "}
              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: "space-between", padding: 2 }}
              >
                <Typography>{vd}</Typography>
                <Typography
                  sx={{
                    fontFamily: "Segoe UI",
                    fontSize: 15,
                    fontWeight: 400,
                    textAlign: "right",
                    color: "#1D5AB9",
                  }}
                >
                  {profileInformation[vd]}
                </Typography>
              </Stack>
              <Divider width={"100%"} />
            </>
          );
        })}
        <Typography
          style={{ height: 45 }}
          variant="titleText"
          color="primary.main"
          marginLeft={2}
          marginTop={2}
        >
          {t("pages.profile.title01")}
        </Typography>
        <Divider width={"100%"} />
        {Object.keys(companyInformation).map((vd, index) => {
          return (
            <div key={index}>
              {" "}
              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: "space-between", padding: 2 }}
              >
                <Typography>{vd}</Typography>
                <Typography
                  sx={{
                    fontFamily: "Segoe UI",
                    fontSize: 15,
                    fontWeight: 400,
                    textAlign: "right",
                    color: "#1D5AB9",
                  }}
                >
                  {companyInformation[vd]}
                </Typography>
              </Stack>
              <Divider width={"100%"} />
            </div>
          );
        })}
        <div>
          <Typography
            style={{ height: 45, fontSize: 18 }}
            color="primary.main"
            marginLeft={2}
            marginTop={2}
          >
            {t("pages.profile.key09")}
          </Typography>
        </div>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Typography
            style={{
              fontFamily: "Segoe UI",
              fontSize: 20,
              fontWeight: 600,
              textAlign: "left",
            }}
          >
            {t("pages.profile.key07")} ?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{
              fontFamily: "Segoe UI",
              fontSize: 18,
              fontWeight: 400,
              textAlign: "left",
            }}
          >
            {t("pages.profile.key08")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            style={{
              alignSelf: "center",
              width: 86,
              height: 32,
              marginLeft: 21,
              marginBottom: 3,
              display: "flex",
              backgroundColor: "#fff",
              borderColor: "#8A8886",
              color: "#605E5C",
              borderRadius: 4,
            }}
            onClick={handleClose}
          >
            <Typography
              variant="buttonText"
              color="common.buttonText"
              style={{ color: "#000" }}
            >
              {t("commonLabels.text24")}
            </Typography>
          </Button>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            variant="contained"
            style={{
              alignSelf: "center",
              width: 106,
              height: 32,
              right: 10,
              marginLeft: 40,
              marginBottom: 3,
              display: "flex",
              borderRadius: 4,
              border: 1,
            }}
          >
            <Typography variant="buttonText" color="common.buttonText">
              {t("commonLabels.text17")}
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ProfileView;
